module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('p', {
    staticClass: "tochead"
  }, [_c('b', [_vm._v("TABLE OF CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('a', {
    attrs: {
      "href": "#/html/04_introduction",
      "id": "intro1"
    }
  }, [_vm._v("INTRODUCTION TO THE ENGLISH EDITION")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('a', {
    attrs: {
      "href": "#/html/05_translate",
      "id": "trans"
    }
  }, [_vm._v("TRANSLATOR’S NOTE by Hilda Nelson")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_preface",
      "id": "preface"
    }
  }, [_vm._v("PREFACE by Jaime Celestino da Costa")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_introduction",
      "id": "intro2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INTRODUCTION by Michel Henriquet")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_chap1",
      "id": "toc1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum1"
  }, [_vm._v("1.")]), _vm._v("Letter: ADDRESSING A FRENCH DISCIPLE")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_chap2",
      "id": "toc2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum1"
  }, [_vm._v("2.")]), _vm._v("Letter: PREPARING THE PASSAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_chap3",
      "id": "toc3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum1"
  }, [_vm._v("3.")]), _vm._v("Letter: SUPPLING IN THE FORWARD MOVEMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_chap4",
      "id": "toc4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum1"
  }, [_vm._v("4.")]), _vm._v("Letter: WORK ON THE LUNGE LINE")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_chap5",
      "id": "toc5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum1"
  }, [_vm._v("5.")]), _vm._v("Letter: ELEVATION OF THE NECK")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_chap6",
      "id": "toc6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum1"
  }, [_vm._v("6.")]), _vm._v("Note: SOME INTERESTING EXERCISES")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_chap7",
      "id": "toc7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum1"
  }, [_vm._v("7.")]), _vm._v("Letter: PREPARATION FOR LEAD CHANGES")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_chap8",
      "id": "toc8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum1"
  }, [_vm._v("8.")]), _vm._v("Letter: DEVELOPING THE PASSAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_chap9",
      "id": "toc9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum1"
  }, [_vm._v("9.")]), _vm._v("Note: WORK IN HAND")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/17_chap10",
      "id": "toc10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("10.")]), _vm._v("Letter: TWO TYPES OF RIDERS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/18_chap11",
      "id": "toc11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("11.")]), _vm._v("Note: WORKING WITH VARIOUS HORSES")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/19_chap12",
      "id": "toc12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("12.")]), _vm._v("Letter: THE PASSING OF A BAUCHERIST")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/20_chap13",
      "id": "toc13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("13.")]), _vm._v("Note: WORKING WITH "), _c('i', [_vm._v("VALIOSO")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/21_chap14",
      "id": "toc14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("14.")]), _vm._v("Letter: BIOGRAPHY")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/22_chap15",
      "id": "toc15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("15.")]), _vm._v("Note: A SHOULDER-IN LESSON")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/23_chap16",
      "id": "toc16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("16.")]), _vm._v("Letter: TWO FRENCH RIDERS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/24_chap17",
      "id": "toc17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("17.")]), _vm._v("Note: STUDY OF PASSAGE AND PIAFFE")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/25_chap18",
      "id": "toc18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("18.")]), _vm._v("Letter: ADVICE ON THE PASSAGE")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/26_chap19",
      "id": "toc19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("19.")]), _vm._v("Note: REMARKS BY THE MASTER")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/27_chap20",
      "id": "toc20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("20.")]), _vm._v("Letter: MISUNDERSTANDINGS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/28_chap21",
      "id": "toc21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("21.")]), _vm._v("Note: A YOUNG HORSE RUSHING AT THE CANTER")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/29_chap22",
      "id": "toc22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("22.")]), _vm._v("Letter: CRITICS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/30_chap23",
      "id": "toc23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("23.")]), _vm._v("Note: SEEKING THE "), _c('i', [_vm._v("RASSEMBLER")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/31_chap24",
      "id": "toc24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("24.")]), _vm._v("Letter: PRESENTATIONS IN ENGLAND")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/32_chap25",
      "id": "toc25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("25.")]), _vm._v("Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/33_chap26",
      "id": "toc26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("26.")]), _vm._v("Note: ADDRESSING LEANING ON THE SHOULDERS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/34_chap27",
      "id": "toc27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("27.")]), _vm._v("Letter: THE RIDER’S SEAT")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/35_chap28",
      "id": "toc28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("28.")]), _vm._v("Letter: FLYING CHANGES")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/36_chap29",
      "id": "toc29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("29.")]), _vm._v("Note: PREPARING A FIVE YEAR OLD")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/37_chap30",
      "id": "toc30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("30.")]), _vm._v("Letter: IMPULSION")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/38_chap31",
      "id": "toc31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("31.")]), _vm._v("Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/39_chap32",
      "id": "toc32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("32.")]), _vm._v("Note: ADDRESSING HEAD TOSSING")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/40_chap33",
      "id": "toc33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("33.")]), _vm._v("Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/41_chap34",
      "id": "toc34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("34.")]), _vm._v("Note: COPING WITH WEIGHT RESISTANCE IN THE HAND")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/42_chap35",
      "id": "toc35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("35.")]), _vm._v("Letter: BAUCHER AND THE SCHOOL OF VERSAILLES")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/43_chap36",
      "id": "toc36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("36.")]), _vm._v("Note: YIELDING OF THE JAW")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/44_chap37",
      "id": "toc37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("37.")]), _vm._v("Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/45_chap38",
      "id": "toc38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("38.")]), _vm._v("Note: TRAINING FLYING CHANGES")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/46_chap39",
      "id": "toc39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("39.")]), _vm._v("Letter: LEAD CHANGES FROM RIGHT TO LEFT")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/47_chap40",
      "id": "toc40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("40.")]), _vm._v("Note: EXERCISE FOR A FOUR-YEAR-OLD HORSE")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/48_chap41",
      "id": "toc41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("41.")]), _vm._v("Letter: THE IDEAL OF "), _c('i', [_vm._v("HAUTE ÉCOLE")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/49_chap42",
      "id": "toc42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("42.")]), _vm._v("Note")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/50_chap43",
      "id": "toc43",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("43.")]), _vm._v("Letter: PROGRAM FOR YOUR RIGID THOROUGHBRED")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/51_chap44",
      "id": "toc44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("44.")]), _vm._v("Note: WORK WITH A FOUR-YEAR-OLD THOROUGHBRED")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/52_chap45",
      "id": "toc45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("45.")]), _vm._v("Letter: WORDS OF A CRITIC")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/53_chap46",
      "id": "toc46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("46.")]), _vm._v("Note: REMARKS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/54_chap47",
      "id": "toc47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("47.")]), _vm._v("Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/55_chap48",
      "id": "toc48",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("48.")]), _vm._v("Note: WORKING WITH VARIOUS HORSES")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/56_chap49",
      "id": "toc49",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("49.")]), _vm._v("Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/57_chap50",
      "id": "toc50",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("50.")]), _vm._v("Note: WORK IN HAND")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/58_chap51",
      "id": "toc51",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("51.")]), _vm._v("Letter: ACADEMIC EQUITATION OF THE ELDERS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/59_chap52",
      "id": "toc52",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("52.")]), _vm._v("Letter: BE AN ARTIST, NOT A FIGHTER")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/60_chap53",
      "id": "toc53",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("53.")]), _vm._v("Note: "), _c('i', [_vm._v("CURIOSO,")]), _vm._v(" SIX MONTHS OF SCHOOLING")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/61_chap54",
      "id": "toc54",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("54.")]), _vm._v("Letter: ARTICLES ABOUT WEMBLEY PRESENTATION")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/62_chap55",
      "id": "toc55",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("55.")]), _vm._v("Note: RIDING THREE ALTER REAL HORSES")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/63_chap56",
      "id": "toc56",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("56.")]), _vm._v("Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/64_chap57",
      "id": "toc57",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("57.")]), _vm._v("Note")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/65_chap58",
      "id": "toc58",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("58.")]), _vm._v("Letter: "), _c('i', [_vm._v("FLORIDO’S")]), _vm._v(" EXCITEMENT")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/66_chap59",
      "id": "toc59",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("59.")]), _vm._v("Note: NUNO RIDING MY HORSES")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/67_chap60",
      "id": "toc60",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("60.")]), _vm._v("Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/68_chap61",
      "id": "toc61",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("61.")]), _vm._v("Note: THE MASTER WORKS WITH "), _c('i', [_vm._v("CORIOLANO")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/69_chap62",
      "id": "toc62",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("62.")]), _vm._v("Letter: NUNO’S REFLECTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/70_chap63",
      "id": "toc63",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("63.")]), _vm._v("Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/71_chap64",
      "id": "toc64",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("64.")]), _vm._v("Note: LETTER FROM JEAN-CLAUDE MENUT")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/72_chap65",
      "id": "toc65",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("65.")]), _vm._v("Note: WORK IN HAND, REMARKS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/73_chap66",
      "id": "toc66",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("66.")]), _vm._v("Letter: TONGUE CONCERNS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/74_chap67",
      "id": "toc67",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("67.")]), _vm._v("Note: PIAFFE IN HAND AND MOUNTED")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/75_chap68",
      "id": "toc68",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("68.")]), _vm._v("Note: THE MASTER RIDES TWO STUDENT HORSES")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/76_chap69",
      "id": "toc69",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("69.")]), _vm._v("Letter: CORRECTING A LATERALIZED WALK")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem"
  }, [_c('span', {
    attrs: {
      "href": "#/html/77_chap70",
      "id": "toc70",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tocnum2"
  }, [_vm._v("70.")]), _vm._v("Letter: NEW YEAR WISHES")])]), _vm._v(" "), _c('p', {
    staticClass: "tocitem1"
  }, [_c('span', {
    attrs: {
      "href": "#/html/78_glossary",
      "id": "glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GLOSSARY")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03736764","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/03_contents.vue
// module id = 66
// module chunks = 0